import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(39, 39, 39, 70%);
  border: 1px solid ${({ theme }) => theme.COLORS.PRIMARY};
  border-radius: 8px;
`;
export const Input = styled.input`
  width: 100%;
  height: 50px;
  padding: 16px;
  text-align: center;
  color: ${({ theme }) => theme.COLORS.TITLE};
  border: 1px solid ${({ theme }) => theme.COLORS.PRIMARY};
  background-color: transparent;
  border-radius: 8px;
  font-weight: 400;
  font-size: 30px;
  outline: none;
  border: none;

  input:-internal-autofill-selected {
    appearance: menulist-button;
    background-image: none !important;
    background-color: transparent;
    color: ${({ theme }) => theme.COLORS.TITLE};
}
`;
export const Label = styled.h3`
  color: ${({ theme }) => theme.COLORS.TITLE};
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 5px;
`;